import { render } from "./oauth-login.vue?vue&type=template&id=605c6afc&scoped=true"
import script from "./oauth-login.vue?vue&type=script&lang=js"
export * from "./oauth-login.vue?vue&type=script&lang=js"

import "./oauth-login.vue?vue&type=style&index=0&id=605c6afc&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605c6afc"]])

export default __exports__